<div class="confirmation-dialog-container aza-cmp-flex-column">
  <h3 mat-dialog-title class="aza-pa-dialog-title">{{'FILE_DOWNLOAD_DIALOG_TITLE' | translate}}</h3>
  <div mat-dialog-content class="aza-pa-dialog-content aza-cmp-flex-item-grow aza-cmp-flex-item-shrink">
    <div class="aza-pa-flex-column">
      <p class="aza-pa-primary-color sticky-top">{{'FILE_DOWNLOAD_DIALOG_CONTENT' | translate}}</p>
      <div class="aza-pa-download-file-list aza-cmp-flex-item-grow aza-cmp-flex-item-shrink">
        @for (item of data.items; track item) {
          <div class="aza-pa-primary-color aza-cmp-flex-row aza-pa-download-file-item aza-cmp-hide-overflow">
            <azavista-flat-button action="download-file--name-{{ item.name }}" color="primary"
              (click)="handleDownloadFile(item, undefined)"
              [class.aza-pa-cursor-no-event]="isDownloadInProgress(item)"
              [containerCssClasses]="['aza-cmp-flex-row']"
              class="aza-cmp-flex-item-grow aza-cmp-flex-item-shrink  aza-cmp-hide-overflow"
              >
              <mat-icon>download</mat-icon>
              <span class="aza-txt-ellipsis aza-cmp-flex-item-grow aza-cmp-flex-item-shrink aza-cmp-hide-overflow">{{item.label}}</span>
            </azavista-flat-button>
            @if (isDownloadInProgress(item)) {
              <mat-progress-spinner
                [mode]="'determinate'"
                [diameter]="18"
                [value]="fileDownloadPercentageMap[item.url]"
              ></mat-progress-spinner>
            }
            @let errorMessage = fileDownloadError[item.url];
            @if (errorMessage) {
              <mat-icon [matTooltip]="errorMessage">error</mat-icon>
            } @else {
              @if (isDownloadCompleted(item)) {
                <mat-icon>check_circle_outline</mat-icon>
              }
              @if (isDownloadInQueue(item)) {
                <mat-icon>schedule</mat-icon>
              }
            }
          </div>
        }
      </div>
    </div>
  </div>
  <div mat-dialog-actions class="aza-pa-dialog-actions">
    <azavista-flat-button action="close" (click)="onCloseClick()" class="aza-pa-dialog-action-cancel-button">
      <span>{{TRANSLATION_MAP.CLOSE| translate }}</span>
    </azavista-flat-button>
    <azavista-button action="download-all" [disabled]="isDownloadingAll" (click)="downloadAllFiles(true)" class="aza-pa-dialog-action-download-all-button" color="primary">
      <span>{{TRANSLATION_MAP.DOWNLOAD_ALL_TO_FOLDER | translate }}</span>
      @if (isDownloadedAll) {
        <mat-icon>check_circle_outline</mat-icon>
      }
    </azavista-button>
  </div>
</div>
